import type { PillCreateConfig } from '../types';

/** Synthetic dispatch key for SETTINGS_BY_TYPE — pills present as `type: 'textbox'`. */
export const PILL_SETTINGS_KEY = 'pill';

export const BOLD_WEIGHT = 700;
export const REGULAR_WEIGHT = 400;

/** Defaults applied by createPill when the caller omits optional fields. */
export const PILL_FACTORY_DEFAULTS = {
  fontWeight: REGULAR_WEIGHT as number | string,
  fontStyle: 'normal' as const,
  textAlign: 'center' as const,
  borderRadius: 0,
  paddingX: 16,
  paddingY: 8,
  minWidth: 0,
  stroke: '#000000',
  strokeWidth: 0
} as const;

/** Visual defaults for a pill inserted from the toolbar. Position is supplied by the caller. */
export const PILL_INSERT_DEFAULTS: Omit<PillCreateConfig, 'left' | 'top'> = {
  text: 'Pill',
  fill: '#FF4D8D',
  textFill: '#FFFFFF',
  fontFamily: 'Arial',
  fontSize: 32,
  fontWeight: BOLD_WEIGHT,
  textAlign: 'center',
  borderRadius: 23,
  paddingX: 24,
  paddingY: 8,
  minWidth: 0
};
